import { Injectable } from '@angular/core';
import { getSecondsBetweenTimes } from '@lentau/ui-kit/core/utils/date.utils';

export type SsrPhaseName = 'cache' | 'authToken' | 'delivery' | 'earlyRequest' | 'bootstrap' | 'renderDone';

export type SsrPhaseMarks = Partial<Record<SsrPhaseName, number>>;

@Injectable({
  providedIn: 'root',
})
export class RenderTimeService {
  private startTime: number = 0;
  private readonly phaseMarksMs: SsrPhaseMarks = {};

  public init(): void {
    this.startTime = Date.now();
    this.phaseMarksMs.cache = undefined;
    this.phaseMarksMs.authToken = undefined;
    this.phaseMarksMs.delivery = undefined;
    this.phaseMarksMs.earlyRequest = undefined;
    this.phaseMarksMs.bootstrap = undefined;
    this.phaseMarksMs.renderDone = undefined;
  }

  public getTime(): number {
    return getSecondsBetweenTimes(this.startTime);
  }

  /** Elapsed ms from init() to now (or 0 if not inited). */
  public getElapsedMs(): number {
    if (!this.startTime) {
      return 0;
    }

    return Date.now() - this.startTime;
  }

  public mark(phase: SsrPhaseName): void {
    if (!this.startTime) {
      this.init();
    }

    this.phaseMarksMs[phase] = this.getElapsedMs();
  }

  public getPhases(): SsrPhaseMarks {
    return { ...this.phaseMarksMs };
  }

  public log(message: string = ''): void {
    console.info(message, this.getTime(), this.getPhases());
  }

  public logPhasesSummary(event: string = 'ssr.phases'): void {
    const phases: SsrPhaseMarks = this.getPhases();
    console.info(event, {
      totalMs: this.getElapsedMs(),
      phases,
    });
  }
}
